module.exports = __webpack_public_path__ + "img/33_61.a4bb3509.png";